import React from "react";
import {listOf, TitleText, InlineText} from "../sectionText";

// Blocs de texte d'une rubrique libre. Tout est rendu comme du texte (jamais de HTML) ; un bloc sans contenu ne rend rien.

export function HeadingBlock({data}) {
    if (!data.title) return null;
    return <h2 className="serif block-heading"><TitleText value={data.title} fallback=""/></h2>;
}

export function SubheadingBlock({data}) {
    if (!data.text) return null;
    return <h3 className="block-subheading">{data.text}</h3>;
}

export function ParagraphBlock({data}) {
    if (!data.text) return null;
    return <p className="block-paragraph"><InlineText value={data.text} fallback=""/></p>;
}

export function QuoteBlock({data}) {
    if (!data.quote) return null;
    return (
        <figure className="block-quote">
            <blockquote>{data.quote}</blockquote>
            {data.author && <figcaption>{data.author}</figcaption>}
        </figure>
    );
}

export function BulletsBlock({data}) {
    const items = listOf(data, "items", []);
    if (items.length === 0) return null;
    return (
        <ul className="block-bullets">
            {items.map((item, i) => <li key={i}>{item.text}</li>)}
        </ul>
    );
}

export function CalloutBlock({data}) {
    if (!data.title && !data.text) return null;
    return (
        <aside className="block-callout">
            {data.title && <strong>{data.title}</strong>}
            {data.text && <p><InlineText value={data.text} fallback=""/></p>}
        </aside>
    );
}
